import React from "react";

function EventSchedule() {
  return (
    <div className="h-fit overflow-hidden px-4 sm:px-6 lg:px-8">
      <section className="bg-white antialiased">
        <div className="max-w-screen-xl mx-auto py-8 sm:py-16 lg:py-24">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-4xl font-extrabold leading-tight tracking-tight text-blue-400">
              Event Schedule
            </h2>

            <div className="mt-4">
              <span className="inline-flex items-center text-lg font-medium text-primary-600 cursor-pointer hover:text-primary-700">
                Learn more about our agenda
                <svg
                  aria-hidden="true"
                  className="w-5 h-5 ml-2"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </span>
            </div>
          </div>

          <div className="overflow-x-auto mt-10">
            <table className="w-full text-sm text-left text-gray-500 border border-gray-200">
              <thead className="text-xs text-white uppercase bg-slate-800">
                <tr>
                  <th scope="col" className="py-3 px-6">
                    Date And Time
                  </th>
                  <th scope="col" className="py-3 px-6">
                    Type Of Event
                  </th>
                  <th scope="col" className="py-3 px-6">
                    Event Location
                  </th>
                  <th scope="col" className="py-3 px-6">
                    Gateway
                  </th>
                  <th scope="col" className="py-3 px-6">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="bg-white border-b hover:border-l-4 hover:border-l-orange-500 hover:bg-gray-50">
                  <th
                    scope="row"
                    className="flex flex-col sm:flex-row items-start sm:items-center py-4 px-6 text-gray-900 whitespace-nowrap"
                  >
                    <div>
                      <div className="text-base font-semibold">
                        Every Other 15 days Fri & Sat
                      </div>
                      <div className="font-normal text-gray-500">10:30 LT</div>
                    </div>
                  </th>
                  <td className="py-4 px-6 text-gray-500">
                    Meklit Humanitarian Association Briefing
                  </td>
                  <td className="py-4 px-6">
                    Meklit Humanitarian Association Head Office
                  </td>
                  <td className="py-4 px-6 text-gray-500">Invitation</td>
                  <td className="py-4 px-6 text-red-500 font-semibold">
                    Inactive
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  );
}

export default EventSchedule;
